/**
 * As classes do formulário que abre dentro da coluna ao lado da grade.
 *
 * Papel: aqui ficam `FORMULARIO_EMBUTIDO`, o bloco cinza de borda arredondada,
 * `ROTULO_EMBUTIDO`, o rótulo mono de 9,5 px em caixa alta, e `CAMPO_EMBUTIDO`,
 * o campo branco e mais baixo que o dos formulários em caixa de diálogo.
 *
 * Como usar: o `FormularioVisita` e o `FormularioAusencia` desenham com estas
 * três, e é o que os faz parecerem um só formulário em duas listas. Um terceiro
 * formulário embutido na coluna deverá usá-las também; o formulário em caixa de
 * diálogo não, porque os rótulos e os campos dele são os dos primitivos.
 *
 * `CAMPO_EMBUTIDO` vale para `Input`, `CampoMascarado`, `Textarea` e
 * `SelectTrigger` igualmente. No `Textarea` ele tira a altura mínima, para o
 * campo começar com a altura de uma linha e crescer com o texto.
 */

/** O bloco do formulário, entre a lista e o botão que o abre. */
export const FORMULARIO_EMBUTIDO =
  'mb-2.5 flex flex-col gap-2 rounded-[4px] border border-linha-forte bg-superficie-2 p-3';

/** O rótulo de cada campo, 3 px acima dele. */
export const ROTULO_EMBUTIDO = 'mb-[3px] block text-[9.5px] leading-[1.6] uppercase';

/** O campo, branco sobre o cinza do bloco. */
export const CAMPO_EMBUTIDO =
  'min-h-0 w-full bg-superficie px-[9px] py-[7px] text-[12.5px] leading-4';
